import React from "react";
import moment from 'moment'
import { useNavigate } from "react-router-dom";
import NoData from "../../loaders/NoData";
import NotificationSkeleton from "./NotificationSkeleton";
import './Notifications.scss'

/* Where a notification points. The server nests it a few levels down, and
   older records may not carry it at all. */
export const notificationLink = (item) =>
    item?.notification?.data?.onActionClick?.bar?.url || "";

/* Today reads as a time, anything older as a date — the full timestamp is
   always on the title attribute. */
const when = (date) => {
    const m = moment(date);
    if (!m.isValid()) return "";
    if (m.isSame(moment(), 'day')) return m.format('LT');
    if (m.isSame(moment().subtract(1, 'day'), 'day')) return 'Yesterday';
    return m.format('DD MMM');
};

const AllNotifications = ({ allNotifications, loading, setOpenNotificationPanel }) => {

    const navigate = useNavigate();

    const open = (item) => {
        const url = notificationLink(item);
        if (!url) return;
        if (setOpenNotificationPanel) setOpenNotificationPanel(false);
        navigate(url);
    };

    if (loading) return <NotificationSkeleton />;

    if (!allNotifications || allNotifications.length === 0) {
        return <NoData
            title="No notifications yet"
            message="Updates about your reports, leaves and tickets will appear here." />;
    }

    return (
        <div className="unread_notifications">
            {allNotifications.map((eachItem, index) => {
                const url = notificationLink(eachItem);

                return (
                <div className={`notification_space_unread${eachItem?.receiver?.read ? '' : ' is-unread'}${url ? ' is-linked' : ''}`}
                    key={index}
                    role={url ? 'button' : undefined}
                    tabIndex={url ? 0 : undefined}
                    onClick={() => open(eachItem)}
                    onKeyDown={(e) => {
                        if (url && (e.key === 'Enter' || e.key === ' ')) {
                            e.preventDefault();
                            open(eachItem);
                        }
                    }}>
                    <div className="notif-row">
                        <div className="notif-icon">{eachItem.icon}</div>

                        <div className="notif-body">
                            <div className="notif-head">
                                <h6>{eachItem.notification.title}</h6>
                                <span className="notification_date"
                                    title={moment(eachItem.createdDate).format('DD MMM YYYY, h:mm A')}>
                                    {when(eachItem.createdDate)}
                                </span>
                            </div>
                            <p className="body_notifications" title={eachItem.notification.body}>
                                {eachItem.notification.body}
                            </p>
                        </div>
                    </div>
                </div>
                );
            })}
        </div>
    )
}

export default AllNotifications
